
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"priceListSSR"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professionTaskSeoName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"citySeoName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peoplePriceTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professionTaskSeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionTaskSeoName"}}},{"kind":"Argument","name":{"kind":"Name","value":"citySeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citySeoName"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medianPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"professionTaskBySeoName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionTaskSeoName"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionMarkdown"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"searchVolume"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"professions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theperson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plural"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objective"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"popularity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urlType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"online"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"professionGroup"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"redirect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cityBySeoName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citySeoName"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":747}};
    doc.loc.source = {"body":"query priceListSSR(\n  $professionTaskSeoName: String!\n  $citySeoName: String\n  $path: String!\n) {\n  peoplePriceTotals(\n    professionTaskSeoName: $professionTaskSeoName\n    citySeoName: $citySeoName\n  ) {\n    minPrice\n    medianPrice\n    maxPrice\n  }\n  professionTaskBySeoName(seoName: $professionTaskSeoName) {\n    id\n    name\n    description\n    descriptionMarkdown\n    seoName\n    unit\n    searchVolume\n    professions {\n      id\n      seoName\n      name\n      theperson\n      plural\n      objective\n      popularity\n      urlType\n      online\n      professionGroup {\n        id\n        seoName\n        name\n      }\n    }\n    contentHtml\n  }\n  redirect(seoName: $path)\n  cityBySeoName(seoName: $citySeoName) {\n    id\n    name\n    seoName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["priceListSSR"] = oneQuery(doc, "priceListSSR");
        
